(function () {
  'use strict';

  var CFG = {
    itemDelay: 120,
    productDelay: 500,
    pillDelay: 200,
    floatDelay: 1600,
    particleCount: 55,
    parallaxStrength: 10
  };

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {

    var items   = document.querySelectorAll('[data-ky-item]');
    var product = document.getElementById('kyProduct');
    var pills   = document.querySelectorAll('.ky-hero__spec-pill');

    items.forEach(function (el, i) {
      setTimeout(function () { el.classList.add('is-visible'); }, 100 + i * CFG.itemDelay);
    });

    if (product) {
      setTimeout(function () {
        product.classList.add('is-visible');
        setTimeout(function () {
          product.style.transition = 'none';
          product.classList.add('is-floating');
        }, CFG.floatDelay);
      }, CFG.productDelay);
    }

    pills.forEach(function (pill, i) {
      setTimeout(function () { pill.classList.add('is-visible'); }, 1800 + i * CFG.pillDelay);
    });

    var visual   = document.getElementById('kyVisual');
    var prodWrap = product;

    if (visual && prodWrap) {
      visual.addEventListener('mousemove', function (e) {
        if (prodWrap.classList.contains('is-floating')) {
          prodWrap.style.animationPlayState = 'paused';
        }
        var rect = visual.getBoundingClientRect();
        var mx = (e.clientX - rect.left)  / rect.width  - 0.5;
        var my = (e.clientY - rect.top)   / rect.height - 0.5;
        var rx = my * -CFG.parallaxStrength;
        var ry = mx *  CFG.parallaxStrength;
        prodWrap.style.transition = 'transform 0.12s ease-out';
        prodWrap.style.transform  = 'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateY(0)';
      });
      visual.addEventListener('mouseleave', function () {
        prodWrap.style.animationPlayState = 'running';
        prodWrap.style.transition = 'transform 1s cubic-bezier(0.23,1,0.32,1)';
        prodWrap.style.transform  = '';
      });
    }

    var canvas = document.getElementById('kyParticles');
    if (!canvas) return;

    /*
      BUG FIX: On mobile, .ky-hero has height:auto (not a fixed viewport height).
      hero.offsetHeight returns the full stacked content height which can be
      600-900px. The canvas gets set to that height and extends beyond the
      hero section, overlaying content below as a transparent-but-black layer.

      Fix: On mobile (<=749px), hide the canvas entirely.
      Particles are a decorative enhancement only and not needed on mobile.
      This eliminates the overflow canvas that was causing the black overlay.
    */
    if (window.innerWidth <= 749) {
      canvas.style.display = 'none';
      return; /* stop here — no canvas init needed on mobile */
    }

    var hero = document.getElementById('kyarna-hero');
    var W = hero.offsetWidth  || window.innerWidth;
    var H = hero.offsetHeight || window.innerHeight;
    canvas.width  = W;
    canvas.height = H;
    var ctx = canvas.getContext('2d');
    var particles = [];
    for (var i = 0; i < CFG.particleCount; i++) {
      particles.push({
        x:  Math.random() * W,
        y:  Math.random() * H,
        r:  Math.random() * 1.0 + 0.25,
        o:  Math.random() * 0.28 + 0.04,
        vx: (Math.random() - 0.5) * 0.14,
        vy: (Math.random() - 0.5) * 0.14,
        sp: Math.random() * 3 + 2
      });
    }
    var tick = 0;
    function drawFrame() {
      ctx.clearRect(0, 0, W, H);
      particles.forEach(function (p) {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = W; if (p.x > W) p.x = 0;
        if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
        var pulse = p.o * (0.5 + 0.5 * Math.sin(tick / p.sp));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(200, 162, 64, ' + pulse + ')';
        ctx.fill();
      });
      tick += 0.022;
      requestAnimationFrame(drawFrame);
    }
    drawFrame();

    var resizeTimer;
    window.addEventListener('resize', function () {
      if (window.innerWidth <= 749) return; /* skip resize on mobile */
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        W = hero.offsetWidth  || window.innerWidth;
        H = hero.offsetHeight || window.innerHeight;
        canvas.width  = W;
        canvas.height = H;
      }, 200);
    });

  });

})();
